<div #tagsContainer class="tag-autowrap__container">
  @for (route of configuration()?.config_routes; track route) {
    <app-lex-xi-tag type="auto-generated" icon="ab_testing" [text]="route.config_route_name">
    </app-lex-xi-tag>
  }
  @if (hasEieTag()) {
    <app-lex-xi-tag
      type="auto-generated"
      icon="app_textAnalytics"
      [text]="getEieTagText()"
      [tooltip]="getEieTagTooltipText()"
    >
    </app-lex-xi-tag>
  }
  @for (tag of configuration()?.tags; track tag) {
    <app-lex-xi-tag type="user" [text]="tag"> </app-lex-xi-tag>
  }

  <app-lex-xi-tag #userEtc type="user-etc"> </app-lex-xi-tag>
</div>
